import React, { useState, Component, useRef } from 'react';
import { Form, Row, Col, FormGroup, Label, Input, Button, Modal, ModalHeader, ModalBody, ModalFooter, FormFeedback } from 'reactstrap';
import { FormattedMessage } from 'react-intl';
import authService from '../api-authorization/AuthorizeService'
import debounce from 'lodash.debounce';


export class CajasPorPaletaView extends Component {
    constructor(props) {
        super(props);
        this.state = {
            productos: []
        };
        if (props.data) {
            this.state.model = props.data
        }
        else {
            this.state.model = { cantidad: "", producto_Id: 0 };
        }
        this.state.modelValidation = {
            cantidad: this.state.model.cantidad != 0,
            producto_Id: this.state.model.producto_Id != 0
        }
        this.handleChange = this.handleChange.bind(this);
        this.validate = this.validate.bind(this);
        this.validate = debounce(this.validate, 1000)
    }
    componentDidMount() {
        this.populateData();
    }
    async populateData() {
        const token = await authService.getAccessToken();

        const response = await fetch('api/productos', {
            headers: !token ? {} : { 'Authorization': `Bearer ${token}` },
        });
        const responceData = await response.json();
        console.log("load_productos", responceData);
        this.setState({ productos: responceData, loading: false });
        //return responceData;
    }
    handleChange(event) {

        var tempModel = this.state.model;
        tempModel[event.target.name] = event.target.value;
        this.setState({
            model: tempModel
        }, () => {
            this.props.setModalBodyState(this.state).then(() => this.validate());
        });
        
    }
    async validate() {
        const token = await authService.getAccessToken();
        const data = JSON.stringify(this.state.model);
        const response = await fetch('api/cajasPorPaleta/validate', {
            method: 'POST',
            headers: !token ? { 'Content-Type': 'application/json' } : { 'Authorization': `Bearer ${token}`, 'Content-Type': 'application/json' },
            body: data
        });
        if (response.ok) {
            var validations = await response.json();
            this.setState({
                modelValidation: validations
            }, () => {
                this.props.setModalBodyState(this.state);
            });
        }
    }
    getValidationValue(value) {
        if (value == null || value == undefined) {
            return true;
        }
        else {
            return value;
        }
    }
    
    render() {
        return (
            <div >
                <Row>
                    <Form>
                        <FormGroup className="col col-md-8">
                            <Label for="producto_Id">
                                <FormattedMessage id='Producto' />
                            </Label>
                            <Input
                                id="producto_Id"
                                name="producto_Id"
                                type="select"
                                onChange={this.handleChange}
                                valid={this.getValidationValue(this.state.modelValidation.producto_Id)}
                                invalid={!this.getValidationValue(this.state.modelValidation.producto_Id)}
                            >
                                <option value="0"></option>
                                {this.state.productos.map(producto => producto.producto_Id == this.state.model.producto_Id ? (
                                    <option value={producto.producto_Id} selected>
                                        {producto.nombre}
                                    </option>
                                ) : (<option value={producto.producto_Id}>{producto.nombre}</option>))}
                            </Input>
                            <FormFeedback>
                                {this.state.model.producto_Id == 0 ? <FormattedMessage id='Este campo es requerido' /> : ""}
                            </FormFeedback>
                        </FormGroup>
                        <FormGroup className="col col-md-6">
                            <Label for="cantidad">
                                <FormattedMessage id='Cantidad' />
                            </Label>
                            <FormattedMessage id='Cantidad'>
                                {(placeholder) =>
                                    <Input
                                        id="cantidad"
                                        name="cantidad"
                                        //placeholder={placeholder}
                                        type="number"
                                        onChange={this.handleChange}
                                        value={this.state.model.cantidad}
                                        valid={this.getValidationValue(this.state.modelValidation.cantidad)}
                                        invalid={!this.getValidationValue(this.state.modelValidation.cantidad)}
                                    />
                                }
                            </FormattedMessage>
                            <FormFeedback>
                                {this.state.model.cantidad == 0 ? <FormattedMessage id='Este campo es requerido' /> : <FormattedMessage id='Esta cantidad de cajas ya esta siendo usada' /> }
                            </FormFeedback>
                        </FormGroup>
                        
                    </Form>
                </Row>
            </div>
        );
    }

}